'use client'
import { Box, Flex, SimpleGrid, Skeleton, Stack } from '@mantine/core'
import { useParams } from 'next/navigation'
import { Suspense } from 'react'

import { SectionErrorBoundary } from '@/components/error/boundary'

import Description from './Description'
import Resources from './Resources'
import styles from './style.module.css'

function AboutFallback() {
  return (
    <Box className={styles.aboutContainer}>
      {/* Description section fallback */}
      <Box pb={0}>
        {/* Title area */}
        <Flex justify="space-between" align="center" mb={16}>
          <Skeleton
            h={32}
            w={200}
            style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
          />
        </Flex>
        {/* Content area fallback */}
        <Box pos="relative">
          <Stack gap={4}>
            {[0, 1, 2, 3].map(index => (
              <Skeleton
                key={index}
                h={16}
                w="100%"
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
              />
            ))}
          </Stack>
          {/* Show more button fallback */}
          <Flex mt={4} justify="center">
            <Skeleton
              h={36}
              w={120}
              style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
            />
          </Flex>
        </Box>
      </Box>

      {/* Resources section fallback */}
      <SimpleGrid cols={{ base: 2, md: 4 }} spacing={16} mt={32}>
        {[0, 1, 2, 3].map(index => (
          <Box key={index}>
            <Stack gap={4}>
              <Skeleton
                h={16}
                w={120}
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
              />
              <Skeleton
                h={20}
                w={80}
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
              />

              <Skeleton
                mt={12}
                h={16}
                w={120}
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
              />
              <Skeleton
                h={20}
                w={80}
                style={{ backgroundColor: 'var(--bg-surface-secondary)', borderRadius: 40 }}
              />
            </Stack>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  )
}

function AboutContent({ hideResources }: { hideResources?: boolean }) {
  const { slug } = useParams<{ slug: string; locale: string }>()

  return (
    <Box className={styles.aboutContainer}>
      <Description />
      {!hideResources && <Resources slug={slug} />}
    </Box>
  )
}

function About({ hideResources }: { hideResources?: boolean }) {
  return (
    <Suspense fallback={<AboutFallback />}>
      <AboutContent hideResources={hideResources} />
    </Suspense>
  )
}

export default SectionErrorBoundary.with(About)
